// extracted by mini-css-extract-plugin
export default {"page":"MintPage_page__EnIIc","counter":"MintPage_counter__GyASh","count":"MintPage_count__WfnZb","mintButton":"MintPage_mintButton__8WW3U","kittens":"MintPage_kittens__G3GDK"};